<template>
  <div>
    <div class="row mb-1">
      <div class="col">
        <h4>Comments</h4>
      </div>
      <div class="col d-flex">
        <button class="btn btn-sm btn-outline-primary ml-auto" v-on:click="getComment();">
          <icon :icon="['fad', 'sync']"/>
          refresh
        </button>
      </div>
    </div>
    <div v-if="processing === false">
      <div v-if="comments.length > 0">
        <ul class="list-group text-left scroller">
          <li class="list-group-item p-1 small" v-for="comment in comments" v-bind:key="comment.id">
            <div class="row">
              <div class="col">
                {{ comment.comment }}
              </div>
            </div>
            <div class="row text-left mt-1">
              <div class="col smaller-comment">
                <div class="m-0 p-0">By {{ comment.name }}</div>
                <div class="m-0 p-0">created {{ comment.created_at | moment("from", "now", true) }} ago</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <div class="row">
          <div class="col">
            No comments.
          </div>
        </div>
      </div>
      <hr>
      <div class="form-row align-items-center mt-3 d-flex">
        <div class="col">
          <div class="row ">
            <div class="col">
              <input type="text" class="form-control form-control-sm" id="inlineFormName" placeholder="Enter your name"
                     v-model="newCommentName" v-on:keydown.enter="createNew">
            </div>
          </div>
          <div class="row mt-1">
            <div class="col">
              <input type="text" class="form-control form-control-sm" id="inlineFormInput" placeholder="Enter comment"
                     v-model="newCommentText" v-on:keydown.enter="createNew">
            </div>
          </div>
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-sm btn-success" v-on:click="createNew">Save</button>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import Loader from "@/components/Loader";

export default {
  name: "Comment",
  components: {Loader},
  props: {
    poster_id: ''
  },
  data() {
    return {
      comments: null,
      processing: true,
      newCommentText: null,
      newCommentName: null,
      intervall: null
    }
  },
  created() {
    this.getComment();
    this.intervall = window.setInterval(() => {
      this.getComment()
    }, 30000)
  },
  beforeDestroy() {
    window.clearInterval(this.intervall);
  },
  methods: {
    ...mapActions([
      'GET_COMMENT', 'CREATE_COMMENT'
    ]),
    async createNew() {
      if (!this.newCommentName || this.newCommentName.length < 1) {
        this.$noty.error("Name is too short");
        return false;
      }
      if (!this.newCommentText || this.newCommentText.length < 1) {
        this.$noty.error("Comment is too short");
        return false;
      }
      this.processing = true;
      this.CREATE_COMMENT({
        'comment': this.newCommentText,
        'name': this.newCommentName,
        'poster_id': this.poster_id
      }).then((response) => {
        this.$noty.success("Comment saved");
        this.newCommentText = null;
        this.processing = false;
        this.getComment();
      }).catch((error) => {
        this.processing = false;
        this.$noty.error("Comment could not be saved");
      })
    },
    async getComment() {
      this.processing = true;
      this.GET_COMMENT(this.poster_id).then((response) => {
        this.processing = false;
        this.comments = response.data;
      }).catch((error) => {
        this.processing = false;
        this.$noty.error("Fehler beim laden.");
      })
    }
  },
  computed: {}
}
</script>

<style type="text/css" scoped>
.scroller {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  height: 70vh !important;
}
</style>
